import React, { ChangeEventHandler, CSSProperties, useContext } from "react";
import './css/singlechoice.css';
import QuestContext from "../../../../components/QuestWrapper";
import { extractGradientColors } from "../../../../general";

type SelectedStyle = {
    accentColor?: string,
    borderColor?: string,
    color?: string
}

interface SingleChoiceProps {
    options: string[];
    checked: string;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    style?: CSSProperties;
    selectedStyle?: SelectedStyle;
    type?: "modal1" | "modal2" | "modal3" | string;
    hoverBackground?: string;
    key?: string | number | undefined;
}

export const SingleChoiceModal1: React.FC<SingleChoiceProps> = ({
    options,
    checked,
    onChange,
    style,
    selectedStyle = { accentColor: "#6525B3" },
    type,
    hoverBackground,
    key
}) => {
    const { themeConfig } = useContext(QuestContext.Context);

    const containerStyle: CSSProperties = {
        ...style,
        flexDirection: type === 'modal2' ? 'column' : 'row',
        gap: type === 'modal2' ? '12px' : '8px'
    };

    if (selectedStyle?.accentColor?.includes("gradient")) {
        selectedStyle.accentColor = extractGradientColors(selectedStyle.accentColor);
    }

    return (
        <div className="q-singlechoice-input-cont" style={containerStyle} key={key}>
            {options.map((option: string, id: number) => {
                const labelContainerStyle: CSSProperties = {
                    border: checked === option
                        ? `1px solid ${selectedStyle?.borderColor || selectedStyle?.accentColor || '#6525B3'}`
                        : `1px solid ${style?.borderColor || "#EFEFEF"}`,
                    width: type === 'modal2' ? '100%' : 'fit-content',
                    padding: type === 'modal2' ? '10px 16px' : '8px 16px',
                    gap: type === 'modal2' ? '8px' : '4px',
                    cursor: 'pointer', // Add a pointer cursor for better UX
                };

                return (
                    <div
                        className="q_singlehoice_label_cont"
                        key={id}
                        style={labelContainerStyle}
                        onClick={(e) => {
                            e.preventDefault();
                            if (onChange) {
                                // Create a synthetic change event instead
                                const syntheticEvent = {
                                    target: { value: option, checked: true }
                                } as React.ChangeEvent<HTMLInputElement>;
                                onChange(syntheticEvent);
                            }
                        }}
                    >
                        {/* <input
                            type="radio"
                            value={option}
                            checked={checked === option}
                            onChange={onChange}
                            className="q-singlechoice-input"
                            style={{ accentColor: selectedStyle?.accentColor || "#6525B3" }}
                            id={option}
                        /> */}
                        {checked !== option ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_68_30)">
                                <mask id="mask0_68_30" x="0" y="0" width="16" height="16">
                                    <path d="M16 0H0V16H16V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_68_30)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 0.833252C4.042 0.833252 0.833374 4.04188 0.833374 7.99992C0.833374 11.958 4.042 15.1666 8.00004 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00004 0.833252ZM1.83337 7.99992C1.83337 4.59416 4.59429 1.83325 8.00004 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00004 14.1666C4.59429 14.1666 1.83337 11.4057 1.83337 7.99992Z" fill={style?.borderColor || "#cacaca"} />
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_68_30">
                                    <rect width="16" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <mask id="mask0_68_23" x="0" y="0" width="16" height="16">
                                <path d="M16 0H0V16H16V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_68_23)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 0.833252C4.042 0.833252 0.833374 4.04188 0.833374 7.99992C0.833374 11.958 4.042 15.1666 8.00004 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99992C15.1667 4.04188 11.9581 0.833252 8.00004 0.833252ZM1.83337 7.99992C1.83337 4.59416 4.59429 1.83325 8.00004 1.83325C11.4058 1.83325 14.1667 4.59416 14.1667 7.99992C14.1667 11.4057 11.4058 14.1666 8.00004 14.1666C4.59429 14.1666 1.83337 11.4057 1.83337 7.99992Z" fill={selectedStyle?.accentColor || "#6525B3"} />
                                <path d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" fill={selectedStyle?.accentColor || "#6525B3"} />
                            </g>
                        </svg>}
                        <label
                            style={{
                                color: checked === option
                                    ? (selectedStyle?.color || selectedStyle?.accentColor || "#6525B3")
                                    : (style?.color || '#939393')
                            }}
                            htmlFor={option}
                        >
                            {option}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};
